import { RARITY_IDS, Rarity } from "../data/balance";

/** The forge's stock in the profile save (`ProfileJson.forge`). */
export interface ForgeJson { essence: number; sigils: number[]; fused: number[]; raisedLevels: number }

const count = (v: unknown): number => (typeof v === "number" && Number.isFinite(v) && v > 0 ? Math.floor(v) : 0);
const perRarity = (v: unknown): number[] => RARITY_IDS.map((_, i) => (Array.isArray(v) ? count(v[i]) : 0));

/**
 * What the forge holds besides the items (gear v2, docs/GEAR_V2.md): Forge Essence (raises items; salvage, battle
 * chests and the free routes pay it), Fusion Sigils per rarity (each stands in for one fodder item in a fusion of its
 * rarity), and lifetime tallies the achievements read (fusions made per result rarity, levels raised).
 */
export class ForgeStock {
  essence = 0;
  readonly sigils: number[] = RARITY_IDS.map(() => 0);
  /** Fusions made, by the rarity they made. */
  readonly fused: number[] = RARITY_IDS.map(() => 0);
  /** Item levels raised with essence, in all. */
  raisedLevels = 0;

  addSigils(rarity: Rarity, n: number): void { if (n > 0 && rarity >= 0 && rarity < this.sigils.length) this.sigils[rarity] += Math.floor(n); }

  toJson(): ForgeJson { return { essence: this.essence, sigils: [...this.sigils], fused: [...this.fused], raisedLevels: this.raisedLevels }; }

  /** Restores field by field (absent on saves before schema 7: an empty forge). */
  load(j: unknown): void {
    const src = (typeof j === "object" && j !== null ? j : {}) as Partial<ForgeJson>;
    this.essence = count(src.essence);
    perRarity(src.sigils).forEach((n, i) => (this.sigils[i] = n));
    perRarity(src.fused).forEach((n, i) => (this.fused[i] = n));
    this.raisedLevels = count(src.raisedLevels);
  }
}
